<template>
  <main-container class="model-predict-result-list-container" title="モデル適用結果一覧" :subTitle="modelName">
    <template slot="main-content">
      <div style="flex-grow: 1; height: 100%;">
        <h3 v-if="predictResults != null && predictResults.length <= 0">適用結果がありません</h3>
        <h3 v-if="predictResults != null && predictResults.length > 0">全件数：{{predictResults.length | number_format}}</h3>
        <fixed-header-table v-if="predictResults != null && predictResults.length > 0" :fixed="true">
          <tr slot="header">
            <th>キー
              <el-popover placement="bottom-start">
                <el-autocomplete :fetch-suggestions="fetchSuggestionsKey" placeholder="IDまたはアップロードファイル名"
                                 v-model="filterKey" :clearable="true" style="width: 400px;"
                                 @change="onChangeFilter"></el-autocomplete>
                <font-awesome-icon slot="reference" class="icon filter" icon="filter" style="margin-left: 16px;"
                                   :class="{ 'has-filter': filterKey }"/>
              </el-popover>
            </th>
            <th>適用日時
              <el-popover placement="bottom-start">
                <div style="display: flex; flex-direction: row; align-items: center;">
                  <el-date-picker v-model="filterFrom" type="date" placeholder="開始日" format="yyyy/MM/dd"
                                  value-format="yyyyMMdd" @change="onChangeFilter"></el-date-picker>
                  <span style="margin: 0 16px;">～</span>
                  <el-date-picker v-model="filterTo" type="date" placeholder="終了日" format="yyyy/MM/dd"
                                  value-format="yyyyMMdd" @change="onChangeFilter"></el-date-picker>
                </div>
                <font-awesome-icon slot="reference" class="icon filter" icon="filter" style="margin-left: 16px;"
                                   :class="{ 'has-filter': (filterFrom || filterTo) }"/>
              </el-popover>
            </th>
            <th>データ件数</th>
            <th style="flex-grow: 0; min-width: 166px; max-width: 166px;"></th>
          </tr>
          <tr v-for="result in filteredPredictResults()">
            <td>{{result.key}}</td>
            <td>{{result.updatedAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DD HH:mm')}}</td>
            <td>
              <template v-if="result.statusCode === 0">{{result.count | number_format}}</template>
              <template v-else-if="result.statusCode === 3">適用中</template>
              <template v-else>適用に失敗しました</template>
            </td>
            <td style="flex-grow: 0; justify-content: center; min-width: 166px; max-width: 166px;">
              <el-button v-if="result.statusCode === 0" style="flex-grow: 1;" type="primary"
                         @click="onClickDownload(result.resultFile)">ダウンロード
              </el-button>
              <template v-else-if="result.statusCode === 3">-</template>
              <el-button v-else style="flex-grow: 1;" type="danger" @click="onConfirmedError(result)">確認</el-button>
            </td>
          </tr>
        </fixed-header-table>
      </div>
    </template>

    <template slot="main-footer">
      <el-button class="large" type="default" @click="onClickBack">戻る</el-button>
      <el-button v-if="isVisibleEvaluatePredict()" type="primary" @click="onClickEvaluatePredict">適用結果の評価</el-button>
    </template>
  </main-container>
</template>

<script lang="js">
import BaseView from '../../base'
import PredictResultDialogCmp from '../../../components/model/predict/dialogs/predict-result'
import WebApiClient from '../../../api/web'
import { ModelDetailInfo } from '../../../defines/model/model'
import { Code } from '../../../api/base'
import CommonUtil from '../../../utils/common'
import DateUtil from '../../../utils/date'
import MessageBox from '../../../utils/message-box'
import { Category } from '../../../defines/const'
import AlgorithmUtil from '../../../utils/algorithm'

export default {
  name: 'ModelPredictView',
  mixins: [BaseView],
  components: {
    'predict-result-dialog': PredictResultDialogCmp

  },
  props: {
    modelId: '',
  },
  data () {
    return {
      modelName: '',
      modelInfo: ModelDetailInfo,
      predictResults: [],

      keyList: [],

      filterKey: '',
      filterFrom: '',
      filterTo: ''

    }
  },
  created () {
    WebApiClient.getModel(this, this.modelId).then(response => {
      if (response.data.code === Code.SUCCESS) {
        this.modelInfo = response.data.result
        this.modelName = this.modelInfo.modelName
        this.$forceUpdate()
        this.loadModelPredictResultList()
      } else {
        this.changeLocation('model-list', null, false, true)
      }
    })
  },
  methods: {
    fetchSuggestionsKey (queryString, callback) {
      const results = CommonUtil.isNotEmpty(queryString) ? this.keyList.filter(
        key => key.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) : this.keyList
      callback(results)
    },

    loadModelPredictResultList () {
      WebApiClient.getModelPredictResultList(this, this.modelId).then((response) => {
        this.predictResults = response.data.result.predictions

        const existKeys = []
        for (const predictResult of this.predictResults) {
          if (existKeys.indexOf(predictResult.key) >= 0) continue
          existKeys.push(predictResult.key)
          this.keyList.push({
            value: predictResult.key
          })
        }
        this.$forceUpdate()
      })
    },

    filteredPredictResults () {
      if (CommonUtil.isEmpty(this.filterKey.concat(this.filterFrom).concat(this.filterTo))) {
        return this.predictResults
      }

      const filterFrom = CommonUtil.isNotEmpty(this.filterFrom) ? DateUtil.parse(this.filterFrom, 'YYYYMMDD') : null
      const filterTo = CommonUtil.isNotEmpty(this.filterTo) ? DateUtil.parse(this.filterTo, 'YYYYMMDD') : null

      return this.predictResults.filter(predictResult => {
        if (predictResult.statusCode !== 0) return true

        const predictDate = DateUtil.parse(predictResult.updatedAt, 'YYYYMMDD')

        if (CommonUtil.isNotEmpty(this.filterKey)) {
          if (predictResult.key.toLowerCase().indexOf(this.filterKey.toLowerCase()) < 0) return false
        }
        if (CommonUtil.isNotNull(filterFrom)) {
          if (!filterFrom.isSameOrBefore(predictDate)) return false
        }
        if (CommonUtil.isNotNull(filterTo)) {
          if (!filterTo.isSameOrAfter(predictDate)) return false
        }

        return true
      })
    },

    onChangeFilter () {
      this.$forceUpdate()
    },

    onClickDownload (downloadUrl) {
      window.location.href = downloadUrl
    },

    onClickEvaluatePredict () {
      this.changeLocation('model-predict-evaluation', {
        modelId: this.modelId,
        modelName: this.modelName
      }, false, true)
    },

    onClickBack () {
      this.$router.push({
        path: `/model/predict/${this.modelId}/`,
        params: {
          modelId: this.modelId,
          modelName: this.modelName
        }
      })
    },

    onConfirmedError (predictResult) {
      MessageBox.confirm(this, `モデルを適用出来ませんでした。<br>データは削除されます。<br>原因不明の場合はお問合せください。`, {
        dangerouslyUseHTMLString: true
      }).then(() => {
        WebApiClient.deleteTask(this, predictResult.predictId).then(() => {
          this.predictResults.splice(this.predictResults.indexOf(predictResult), 1)
          this.$forceUpdate()
        })
      }).catch(() => {})
    },

    isVisibleEvaluatePredict () {
      if (CommonUtil.isEmpty(this.modelInfo)) {
        return false
      } else {
        const purpose = AlgorithmUtil.algorithm2Purpose(this.modelInfo.categoryId,
          this.modelInfo.algorithm.algorithmId)
        if ([Category.CLF, Category.REG].indexOf(purpose) >= 0) {
          if (purpose === Category.CLF) {
            if (CommonUtil.isEmpty(this.modelInfo.yClasses) || this.modelInfo.yClasses.length > 2) {
              return false
            }
          }
          return true
        }
        return false
      }
    }
  }
}

</script>

<style scoped>
  .model-predict-result-list-container >>> .main-content {
    display: flex;
    flex-direction: column;
    padding: 24px;
  }

  .icon.filter {
    cursor: pointer;
  }

  .icon.filter:hover {
    opacity: 0.7;
  }

  .icon.filter.has-filter {
    color: #2456d4;
  }
</style>



// WEBPACK FOOTER //
// src/views/model/predict/result-list.vue